import React from 'react'
import { observer } from 'mobx-react'
import { ColumnId } from 'admin/staffing/components/StaffingTable/StaffingTableColumns'
import StaffingViewModel from 'admin/staffing/components/Staffing/StaffingViewModel'
import InfiniteScrollLoader from 'components/InfiniteScrollLoader'
import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
} from 'components/Table/ClickableTable'
import StaffingTableRow from '../StaffingTableRow'
import Checkbox from 'components/Checkbox'
import { SelectionState } from 'admin/staffing/components/StaffingTable/StaffingSearchViewModel'
import { match } from 'utils/pattern-match-util'

interface StaffingTableProps {
  vm: StaffingViewModel
}

export default observer(function StaffingTable({ vm }: StaffingTableProps) {
  const columns = vm.columns
  const searcher = vm.searcher

  return (
    <>
      <Table striped>
        <TableHead>
          {columns.map((column) =>
            column.id === ColumnId.Checkbox ? (
              <TableHeader
                key={column.id}
                className={column.styles}
                alignment={column.align}
              >
                <Checkbox
                  onChange={() => searcher.toggleAllPostings()}
                  checked={match(searcher.selectionState, {
                    [SelectionState.AllSelected]: () => true,
                    [SelectionState.NoneSelected]: () => false,
                    [SelectionState.SomeSelected]: () =>
                      'indeterminate' as boolean | 'indeterminate',
                  })}
                  data-test="staffing-table-select-all"
                />
              </TableHeader>
            ) : (
              <TableHeader
                key={column.id}
                className={column.styles}
                canSort={column.sortable}
                sortOrder={vm.getSortOrder(column)}
                onSort={(newSort) => {
                  vm.setSortOrder(column, newSort)
                }}
                alignment={column.align}
              >
                {column.header}
              </TableHeader>
            ),
          )}
        </TableHead>
        <TableBody>
          {vm.filteredItems.map((item) => (
            <StaffingTableRow vm={vm} workspacePosting={item} key={item.id} />
          ))}
        </TableBody>
      </Table>
      {!searcher.scroller.isDone && (
        <InfiniteScrollLoader scrollProvider={searcher.scroller} />
      )}
    </>
  )
})
